<template>
  <div>
    <Header></Header>
    <div class="banner">
      <div class="word">
        <div style="font-size: 42px;font-family: Source Han Sans CN;color: #FFFFFF;line-height: 46px;">
          企业上节点
        </div>
        <div style="font-size: 16px;font-family: Adobe Heiti Std;color: #FFFFFF;line-height: 46px;">
          <div class="applyBtn"><a href="https://snms.idshanxi.com/" target="_blank">申请入口</a></div>
        </div>

      </div>
    </div>
    <div class="zdbz">指导步骤</div>
    <div class="content">

      <div class="timeline">
        <div class="leftLine">
          <div v-for="(item, index) in pagaData" :key="index">
            <div class="one" :class="{'active':active==index}" @mouseover="mouseOver(index)" @mouseleave="mouseLeave">
              0{{index + 1}}</div>
            <div class="line" :class="{'active':active==index}">
              <div v-if="index == 2" class="sj" :class="{'sj1':active==2}"></div>
            </div>
          </div>
        </div>
        <div class="rightLine">
          <div v-for="(item, index) in pagaData" :key="index">
            <div class="one" @mouseover="mouseOver(index)" @mouseleave="mouseLeave()"
              :class="[{'activeBG':active==index}, 'item' + index]">
              <div class="title">
                <img v-if="index == 0"
                  :src="active == 0 ? require('../../assets/images/011@2x.png') : require('../../assets/images/01@2x.png')"
                  width="38px" height="46px">
                <img v-if="index == 1"
                  :src="active == 1 ? require('../../assets/images/022@2x.png') : require('../../assets/images/02@2x.png')"
                  width="48px" height="48px">
                <img v-if="index == 2"
                  :src="active == 2 ? require('../../assets/images/033@2x.png') : require('../../assets/images/03@2x.png')"
                  width="47px" height="46px">
                <span :class="{'active1':active==index}">{{item.title}}</span>
              </div>
              <div class="text" :class="{'active1':active==index}">
                {{item.contentTitle}}
              </div>
            </div>
          </div>

          <!-- <div class="one" @mouseover="mouseOver(1)" @mouseleave="mouseLeave()" :class="{'activeBG':active==1}">
            <div class="title">
              <img
                :src="active == 1 ? require('../../assets/images/011@2x.png') : require('../../assets/images/01@2x.png')"
                alt="">
              <span :class="{'active1':active==1}">提出申请</span>
            </div>
            <div class="text" :class="{'active1':active==1}">
              企业登录工业互联网标识解析二级节点平台申请企业前缀，提交相关企业信息（企业名称、企业统一社会信用代码、企业法人信息等），并提交审核；
            </div>
          </div>
          <div class="two" @mouseover="mouseOver(2)" @mouseleave="mouseLeave()" :class="{'activeBG':active==2}">
            <div class="title">
              <img
                :src="active == 2 ? require('../../assets/images/022@2x.png') : require('../../assets/images/02@2x.png')"
                alt="">
              <span :class="{'active1':active==2}">审核通过</span>
            </div>
            <div class="text" :class="{'active1':active==2}">
              审核通过后，企业可登录工业互联网标识解析二级节点平台查看相关信息（如企业标识前缀信息、企业账号、企业密钥等），并下载数据字典等相关资料；
            </div>
          </div>
          <div class="three" @mouseover="mouseOver(3)" @mouseleave="mouseLeave()" :class="{'activeBG':active==3}">
            <div class="title">
              <img
                :src="active == 3 ? require('../../assets/images/033@2x.png') : require('../../assets/images/03@2x.png')"
                alt="">
              <span :class="{'active1':active==3}">标识注册</span>
            </div>
            <div class="text" :class="{'active1':active==3}">
              企业调用相关接口接入工业互联网二级节点，进行标识注册等（标识注册、标识修改、标识删除等）操作。
            </div>
          </div> -->
        </div>
      </div>
      <div class="img">
        <img src="../../assets/images/IMG@2x.png" width="675px" height="782px">
      </div>
    </div>
    <Contact/>
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import Contact from './Contact.vue'
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    contentByType
  } from '@/api/api'
  export default {
    data() {
      return {
        pagaData: [],
        active: null,
        serverUrl: serverUrl.baseURL
      }
    },
    components: {
      Header,
      Footer,
      Contact
    },
    mounted() {
      this.getContentByType()
    },
    methods: {
      mouseOver(index) {
        this.active = index
        console.log(index)
      },
      mouseLeave() {
        this.active = null
      },
      getContentByType() {
        contentByType({
          type: 6
        }).then(res => {
          this.pagaData = res.data
        })
      }
    }
  }
</script>

<style scoped>
  .banner {
    width: 100%;
    height: 480px;
    background: url(../../assets/images/qiyeNode@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }

  .content {
    width: 1337px;
    display: flex;
    justify-content: space-between;
    margin: 50px auto 80px;
  }

  .timeline {
    width: 1300px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    height: 782px;
    margin-right: 45px;
  }

  .word {
    width: 1300px;
    margin: 0 auto;
  }

  .zdbz {
    margin-top: 60px;
    text-align: center;
    font-size: 48px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
  }

  .leftLine {
    width: 70px;
    margin-right: 20px;
  }

  .leftLine .one,
  .leftLine .two,
  .leftLine .three {
    width: 70px;
    height: 70px;
    text-align: center;
    line-height: 70px;
    font-size: 30px;
    font-family: Arial;
    font-weight: bold;
    color: #FFFFFF;
    background: #B3B3B3;
    border-radius: 50%;
    cursor: pointer;
  }

  .active {
    background: #0F5BE8 !important;
  }

  .line {
    width: 2px;
    height: 166px;
    background: #B3B3B3;
    margin: 10px auto;
    position: relative;
  }

  .rightLine .one,
  .rightLine .two,
  .rightLine .three {
    padding: 40px 60px;
    box-sizing: border-box;
    width: 601px;
    height: 222px;
    cursor: pointer;
    margin-bottom: 45px;
  }

  .item0 {
    background: url(../../assets/images/one@2x.png) top center no-repeat;
    background-size: cover;
  }

  .activeBG {
    background: url(../../assets/images/hover@2x.png) top center no-repeat !important;
    background-size: cover;
  }

  .item1 {
    margin-top: 40px;
    background: url(../../assets/images/two@2x.png) top center no-repeat;
    background-size: cover;
  }

  .item2 {
    margin-top: 50px;
    background: url(../../assets/images/three@2x.png) top center no-repeat;
    background-size: cover;
  }

  .img {
    height: 782px;
  }

  .rightLine .one img {
    margin-right: 20px;
    /* width: 38px;
    height: 46px; */
  }

  .rightLine .two img {
    margin-right: 20px;
    /* width: 48px;
    height: 48px; */
  }

  .rightLine .three img {
    margin-right: 20px;
   /* width: 47px;
    height: 46px; */
  }

  .rightLine span {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
  }

  .rightLine .title {
    display: flex;
    align-items: center;
  }

  .rightLine .text {
    margin-top: 20px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: #7D889B;
    line-height: 26px;
  }

  .active1 {
    color: #fff !important;
  }

  .threeLine {
    position: relative;
  }

  .sj {
    position: absolute;
    width: 0px;
    height: 0px;
    border: 5px solid transparent;
    border-top-color: #B3B3B3;
    bottom: -10px;
    left: -4px;
  }

  .sj1 {
    border-top-color: #0F5BE8 !important;
  }
  .applyBtn{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    border: 2px solid rgba(255,255,255,0.3);
    border-radius: 10px;
    display: inline-block;
    line-height: 16px;
    margin-top: 20px;
    cursor: pointer;
  }
  .applyBtn a {
    color: #fff;
    padding: 12px 40px;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/views/node/EnterpriseNode.vue